import { Button, Grid, Box } from "@mui/material";
import DataTable from "../../../components/features/Datatable";
import Filter from "./Filter";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { hasAuthority } from "../../../../utils/authorities";
import { getRecievedLSMListing } from "../../../slices/logisticSlice";
import { filterConfigRecived } from "../../../utils/common/utils";
import { addPatientList, addPhaseList } from "../../../slices/chat";
import ChatModule from "../../Chat";
import { useNavigate } from "react-router";
import {capitalizeWords} from "../../../../utils/utils"


const LSMReceived = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate()
  const LoginData = useSelector((state) => state.loginData);
  const bmr_permissions = LoginData?.bmr_permissions || [];
  const { recievedLSMList } = useSelector((state) => state.bmrLogistic);

  const updateFilter = (filter) => {
    fetchUsers(filter);
  };

  const fetchUsers = async (filter) => {
    await dispatch(getRecievedLSMListing(filter));
  };

  const columns = [
    {
      id: "subject_code",
      name: "ID",
      selector: (row) => (row.subject_code ? row.subject_code : "N/A"),
      sortable: true,
    },
    {
      id: "subject_name",
      name: "Subject Name",
      selector: (row) => (row.subject_name ? capitalizeWords(row.subject_name) : "N/A"),
      sortable: true,
    },
    {
      id: "product_phase",
      name: "Product/Phase",
      selector: (row) =>
        row.product_name && row.product_name
          ? `${capitalizeWords(row.product_name)}/${capitalizeWords(row.phase_name)}`
          : "N/A",
      sortable: true,
    },

    {
      id: "phase_type",
      name: "Type",
      selector: (row) => (row.phase_type ? row.phase_type : "N/A"),
      sortable: true,
    },
    {
      id: "hospital_name",
      name: "Hospital",
      selector: (row) => (row.hospital_name ? row.hospital_name : "N/A"),
      sortable: true,
    },
    {
      id: "disease",
      name: "Disease",
      selector: (row) => (row.disease ? capitalizeWords(row.disease) : "N/A"),
      sortable: true,
    },
    {
      name: "Action",
      selector: (row) => (
        <div className="flex gap-[10px]">
          <Button
            onClick={() => {
              navigate(`/bmr/lsm-acceptance/lsm-received/details/${row?.qr_code_generated_id}/${row?.feasibility_id}`,{
                 state: [
            { name: "LSM Received", path: location.pathname },
            {
              name: "Details",
              path: `/bmr/lsm-acceptance/lsm-received/details/${row?.qr_code_generated_id}/${row?.feasibility_id}`,
            },
            ]
              })
            }}
            disabled={Boolean(row.queries?.length)}
            key={row.id}
            size="small"
            className="!w-[100px] "
          >
            View Details
          </Button>
        </div >
      ),
    },
  ];



  ////////// phase and pantient List for chat bot ///////////

  useEffect(() => {
    const phaseList = recievedLSMList?.items?.map(op => { return { value: op?.phase_id, label: `${op?.phase_name} (${op?.product_name})`, patient_id: op?.subject_id } })
    const patientList = recievedLSMList?.items?.map(op => { return { value: op?.subject_id, label: `${op?.subject_name}`, phase_id: op?.phase_id } })
    dispatch(addPatientList(patientList))
    dispatch(addPhaseList(phaseList))
  }, [recievedLSMList])

  ////////////////////////////////////////////////////////////

  return (
    <Box>
      <Grid
        container
        className="mt-4 ml-0 mr-3 mainDiv"
        rowSpacing={4.5}
        columnSpacing={2.75}
      >
        <Grid item xs={12} sx={{ mt: -2.25 }}>
          {hasAuthority(["lsm-received-listing"], bmr_permissions) && (
            <DataTable
              columns={columns}
              data={recievedLSMList}
              title="Subject"
              FilterComponent={Filter}
              onServerSideChange={updateFilter}
              remote={true}
              filterConfig={filterConfigRecived}
            />
          )}
        </Grid>
      </Grid>
      <ChatModule />
    </Box>
  );
};

export default LSMReceived;
